export const LegTypeCode = {
  Win: 'W',
  Place: 'P',
  WinPlace: 'WP',
}
